import React from 'react';
import TextValue from '../../../../../text/TextValue';
import DataGrid from '../../../../../table/DataGrid';
import {
  Table,
  TableContainer,
  TableRow,
  Typography,
  Box,
  TableHead,
  TableBody,
  TableCell
} from '@mui/material';
import TextEllipsis from '../../../../../text/TextEllipsis';

const MarkingPeriodicalReport = ({ detail }) => {
  const groupBy = 'studentId';
  const listData = groupBy
    ? detail?.students.reduce((acc, item) => {
        const groupNameBy = item[groupBy] || 'General';
        if (!acc[groupNameBy]) acc[groupNameBy] = [];
        acc[groupNameBy].push(item);
        return acc;
      }, {})
    : { 'General': detail?.students };

  return (
    <div>
      <TextValue title='Periodical report' value={detail?.name} />
      <div className='py-2' />
      <div className='h-screen-2/5 relative'>
        <TableContainer className='absolute inset-0 flex flex-col' component={Box}>
          <Table>
            <TableHead className='sticky top-0px z-10'>
              <TableRow>
                <TableCell
                  style={{
                    outline: '1px solid var(--muted)'
                  }}
                >
                  Students (#{Object.keys(listData).length || 0})
                </TableCell>
                <TableCell
                  key={`periodical-assessment-area-group`}
                  className='text-center'
                  style={{
                    padding: '0 0.5rem',
                    outline: '1px solid var(--muted)'
                  }}
                >
                  Assessment Area
                </TableCell>
                <TableCell
                  key={`periodical-current`}
                  className={`text-center`}
                  width={100}
                  style={{
                    outline: '1px solid var(--muted)'
                  }}
                >
                  Level
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody className='relative'>
              {detail?.students?.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={3} className='text-center'>
                    <Typography
                      color='inherit'
                      component={'p'}
                      className='text-muted-foreground opacity-50 py-2 text-center'
                    >
                      You don't have any students yet
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : (
                Object.keys(listData).map((key) => {
                  const row = listData[key]?.[0] || {};
                  const marking = listData[key] || [];
                  return (
                    <React.Fragment key={`student-${key}`}>
                      <TableRow key={`student-${key}-marking-0`}>
                        <TableCell
                          rowSpan={marking.length}
                          style={{
                            outline: '1px solid var(--muted)'
                          }}
                          className='bg-white'
                        >
                          <div className='max-w-150px min-w-150px flex flex-col'>
                            <TextEllipsis>
                              {row?.studentCode}
                              {row?.studentName ? ` - ${row?.studentName}` : ''}
                            </TextEllipsis>
                            <Typography className='text-sm text-primary'>{row?.studentYearLevel}</Typography>
                          </div>
                        </TableCell>
                        <TableCell
                          style={{
                            outline: '1px solid var(--muted)'
                          }}
                        >
                          <div className='max-w-130px'>
                            <TextEllipsis>{marking[0]?.assessmentAreaName}</TextEllipsis>
                          </div>
                        </TableCell>
                        <TableCell
                          align='center'
                          style={{
                            outline: '1px solid var(--muted)'
                          }}
                        >
                          <div className='flex gap-2 justify-center'>
                            <Typography color='error' className='line-through opacity-75'>
                              {marking[0]?.oldLevel}
                            </Typography>
                            <Typography>{marking[0]?.level}</Typography>
                          </div>
                        </TableCell>
                      </TableRow>
                      {marking.slice(1)?.map((item, index) => (
                        <TableRow key={`student-${key}-marking-${index + 1}`}>
                          <TableCell
                            style={{
                              outline: '1px solid var(--muted)'
                            }}
                          >
                            <div className='max-w-120px'>
                              <TextEllipsis>{item?.assessmentAreaName}</TextEllipsis>
                            </div>
                          </TableCell>
                          <TableCell
                            align='center'
                            style={{
                              outline: '1px solid var(--muted)'
                            }}
                          >
                            <div className='flex gap-2 justify-center'>
                              <Typography color='error' className='line-through opacity-75'>
                                {item?.oldLevel}
                              </Typography>
                              <Typography>{item?.level}</Typography>
                            </div>
                          </TableCell>
                        </TableRow>
                      ))}
                    </React.Fragment>
                  );
                })
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
};

export default MarkingPeriodicalReport;
